import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import { useStyles } from "./tasksTabs.styles";

export const TasksTabs = ({
  completedInfiniteRef,
  completedTasks,
  allInfiniteRef,
  allTasks,
  selectedTab,
  setSelectedTab,
}) => {
  const classes = useStyles();

  const getCompletedTasks = () => {
    setSelectedTab("Completed");
  };

  const getAllTasks = () => {
    setSelectedTab("allTasks");
  };

  return (
    <Grid container className={classes.tabsContainer} spacing={2}>
      <Grid
        onClick={getAllTasks}
        item
        className={classes.tabOption}
        ref={allInfiniteRef}
      >
        All Tasks <span className={classes.totalTasks}>{allTasks}</span>
        {selectedTab === "allTasks" && (
          <div className={classes.underNeathDiv} />
        )}
      </Grid>
      <Grid
        onClick={getCompletedTasks}
        item
        className={classes.tabOption}
        ref={completedInfiniteRef}
      >
        Completed <span className={classes.totalTasks}>{completedTasks}</span>
        {selectedTab === "Completed" && (
          <div className={classes.underNeathDiv} />
        )}
      </Grid>
    </Grid>
  );
};

TasksTabs.propTypes = {
  completedInfiniteRef: PropTypes.shape({
    current: PropTypes.instanceOf(Object),
  }).isRequired,
  completedTasks: PropTypes.number.isRequired,
  allInfiniteRef: PropTypes.shape({
    current: PropTypes.instanceOf(Object),
  }).isRequired,
  allTasks: PropTypes.number.isRequired,
  selectedTab: PropTypes.string.isRequired,
  setSelectedTab: PropTypes.func.isRequired,
};
